// extracted by mini-css-extract-plugin
module.exports = {"notification-bar":"page_notification-bar__ApuyJ"};